import styles from "./AssessmentReport.module.css";
import SearchBar from "../../../components/SearchBar/SearchBar";
import Dropdown from "../../../components/Dropdown/Dropdown";
import Dynamic from "../../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../../components/LogoWithName/LogoWithName";
import Action from "../../../components/Action/Action";
import { FiInfo } from "react-icons/fi";
import IconAndName from "../../../components/IconAndName/IconAndName";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa"; // at the top
const data = [
  { _id: "1", name: "John Jacob", status: "Success" },
  { _id: "2", name: "John Jacob", status: "Pending" },
  { _id: "3", name: "John Jacob", status: "Pending" },
  { _id: "4", name: "John Jacob", status: "Pending" },
];
  

const downloadTableData = () => {
  const csvContent =
    "data:text/csv;charset=utf-8," +
    ["Student Name,Status"]
      .concat(data.map((item) => `${item.name},${item.status}`))
      .join("\n");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "assessment_report.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  

function AssessmentReport() {
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  

  const getColumnData = (data) => {
    return data.map((item) => {
      const status = item.status.toLowerCase();
      const isPending = status === "pending";
      const isSuccess = status === "success";

      return {
        studentName: (
          <LogoWithName
            name={item.name}
            textColor="var(--Primary_Color)"
            bgColor="var(--Utility_Color1)"
          />
        ),
        status: (
          <span
            style={{
              color: isPending ? "var(--Error_Color)" : "var(--Success_Color)",
              display: "flex",
              alignItems: "center",
              gap: "0.4rem",
              fontWeight: 500,
            }}
          >
            {isPending && <FaExclamationCircle />}
            {isSuccess && <FaCheckCircle />}
            {item.status}
          </span>
        ),
      };
    });
  };
  

  const displayData = getColumnData(data);

  const headingsData = [
    { title: "Student Name", accessor: "studentName" },
    { title: "Status", accessor: "status" },
  ];
  

  return (
    <div className={styles.headerContainer}>
     
      <div className={styles.totalstudentcard}>
        <div className={styles.header}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search activity"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.dropdown}>
            <Dropdown
              label="Room"
              options={["Room 1", "Room 2"]}
              value={selectedRoom}
              onChange={setSelectedRoom}
            />
            <Dropdown
              label="Groups"
              options={["Group A", "Group B"]}
              value={selectedGroup}
              onChange={setSelectedGroup}
            />
            <Dropdown
              label="Assessment Template"
              options={["Template 1", "Template 2"]}
              value={selectedTemplate}
              onChange={setSelectedTemplate}
            />
            <IconAndName title="Download" onClick={downloadTableData} />
          </div>
        </div>

        <div className={styles.dynamicdata}>
          <Dynamic
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>
        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default AssessmentReport;
